import React, {useEffect}  from "react";
import Header from "../components/common/Header";
import SideBar from "../components/common/SideBar";
import PMCSoftLaunch from "../components/SoftAndHardLaunch/PMCSoftLaunch";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import HomeWishes from "../components/common/HomeWishes";
import SkeletonMessage from "../loaders/SkeletonMessage";

function ReRegPMC() {
  const history = useHistory();
  const reload = useSelector(state => state.registrations.reload);
  
  const user = useSelector((state) => state.user);
  const pmcReRegActive = JSON.parse(localStorage.getItem('PMCReRegStatus'));
  const registrationsLoading = useSelector((state) => state.registrations.loading);
  const pmcReregData = useSelector(state => state.isReReg.pmcReregData);  

  if (user.status === "On Hold" ) {
    history.push("/status");
  }else if ((user.status !== "On Hold" ) && (!pmcReRegActive || !pmcReregData || pmcReregData.length === 0)) {
    history.push("/home");
  }
  useEffect(() => {
    if (user.status === "On Hold" ) {
      history.push("/status");
    }else if ((user.status !== "On Hold" ) && (!pmcReRegActive || !pmcReregData || pmcReregData.length === 0)) {
      history.push("/home");
    }
  }, [user.status, pmcReRegActive, pmcReregData, history, reload]);
  
  return (
    <>
    <Header></Header>
    <div className="content-wrapper d-flex flex-wrap on-hold-height">
    <SideBar></SideBar>
    <div className="sidebar-right">
    <div className="home-list-wrap">
    <HomeWishes />
    {registrationsLoading ? <SkeletonMessage /> : <PMCSoftLaunch />}
    </div>
    </div>
    </div>
    </>
  )
}

export default ReRegPMC;
